import { Button } from "@/components/ui/button";
import { ScrollArea } from "@/components/ui/scroll-area";
import { Trash2, Zap, Activity, Triangle } from "lucide-react";

const typeIcons = {
  "DC Power": Zap,
  "Single-Phase AC": Activity,
  "Three-Phase AC": Triangle
};

export const CalculationHistory = ({ history, onClear }) => {
  if (history.length === 0) {
    return (
      <div className="p-6 text-center">
        <div className="w-12 h-12 rounded-full bg-secondary/50 flex items-center justify-center mx-auto mb-3">
          <Zap className="h-6 w-6 text-muted-foreground" />
        </div>
        <p className="text-sm text-muted-foreground">
          No calculations saved yet.
        </p>
        <p className="text-xs text-muted-foreground mt-1">
          Your last 5 calculations will appear here.
        </p>
      </div>
    );
  }

  return (
    <div className="flex flex-col h-[calc(100%-4rem)]">
      <ScrollArea className="flex-1 px-4">
        <div className="space-y-3 py-4">
          {history.map((item) => {
            const Icon = typeIcons[item.type] || Zap;
            const timestamp = new Date(item.timestamp).toLocaleString(undefined, {
              month: 'short',
              day: 'numeric',
              hour: '2-digit',
              minute: '2-digit'
            });

            return (
              <div
                key={item.id}
                className="p-3 rounded-lg bg-secondary/30 border border-border hover:border-primary/30 transition-colors"
              >
                <div className="flex items-center gap-2 mb-2">
                  <Icon className="h-4 w-4 text-primary" />
                  <span className="text-sm font-medium text-foreground">
                    {item.type}
                  </span>
                  <span className="text-xs text-muted-foreground ml-auto">
                    {timestamp}
                  </span>
                </div>

                {/* Inputs */}
                <div className="mb-2">
                  <p className="text-xs text-muted-foreground mb-1">Inputs:</p>
                  <div className="flex flex-wrap gap-1">
                    {Object.entries(item.inputs).map(([key, value]) => (
                      <span
                        key={key}
                        className="text-xs px-2 py-0.5 rounded bg-secondary text-secondary-foreground"
                      >
                        {value}
                      </span>
                    ))}
                  </div>
                </div>

                {/* Outputs */}
                <div>
                  <p className="text-xs text-muted-foreground mb-1">Results:</p>
                  <div className="space-y-1">
                    {Object.entries(item.outputs).map(([key, value]) => (
                      <div key={key} className="flex justify-between text-xs">
                        <span className="text-muted-foreground capitalize">
                          {key.replace(/([A-Z])/g, ' $1').trim()}:
                        </span>
                        <span className="font-mono text-primary">{value}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </ScrollArea>

      <div className="p-4 border-t border-border">
        <Button
          variant="outline"
          size="sm"
          onClick={onClear}
          className="w-full gap-2 text-destructive hover:text-destructive hover:bg-destructive/10"
        >
          <Trash2 className="h-4 w-4" />
          Clear History
        </Button>
      </div>
    </div>
  );
};
